import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Connectprofile() {
  return (
    <section className="client_expectation p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/teemates/connect_profile.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={556}
              height={620}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>1. Create and connect with other golfing profiles</h2>
            <p>
              App users can create new profiles, add their personal information,
              network with golfing mates in nearby areas, and share their
              stories via visuals.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Connectprofile;
